/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Ishidden1Inputs */

const en_entity_ishidden1 = /** @type {(inputs: Entity_Ishidden1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Hidden`)
};

const de_entity_ishidden1 = /** @type {(inputs: Entity_Ishidden1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist versteckt`)
};

/**
* | output |
* | --- |
* | "Is Hidden" |
*
* @param {Entity_Ishidden1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_ishidden1 = /** @type {((inputs?: Entity_Ishidden1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Ishidden1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_ishidden1(inputs)
	return de_entity_ishidden1(inputs)
});
export { entity_ishidden1 as "entity_isHidden" }